import { c as _c } from "react/compiler-runtime";
import './Divider.scss';
export function Divider() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <hr className="divider" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}